import service from '@/utils/server';

const modName='/md/areaCity/';

export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  let config = {
    timeout: 500000,
    responseType: 'blob'
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

export const areaCityEditInit = data => {
  return service({
    url: modName + 'areaCityEditInit',
    method: 'post',
    data
  });
};

export const submit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

export const deleteAreaCity = data => {
  return service({
    url: modName + 'delete',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/areaCity/api/index.js